import { useCallback, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import classNames from 'classnames';

import { MessageVariable } from '@anyx/common-graphql';


export type VariableType = 'text' | 'url';

export type VariablePluginOption = {
  value: string;
  label: ReactNode;
  type: VariableType;
};

const URL_VARIABLES: Partial<MessageVariable>[] = [
  MessageVariable.ORDER_STATUS_URL,
  MessageVariable.ORDER_TRACKING_URL,
];

export const variableBlockBaseClass = 'rounded-sm border border-solid px-[3px] text-xs leading-4.5';

export const useGenerateVariablePluginOptions = () => {
  const { t } = useTranslation('crm');

  const generateVariableOptions = useCallback(
    (variables: MessageVariable[] = []): VariablePluginOption[] => {
      return variables.map((variable) => {
        const description = t(`crm.richTextEditor.plugins.variable.option.description`, {
          variable,
        });
        const value = `{{${variable}}}`;

        return {
          value,
          label: (
            <div className="flex items-center gap-x-1">
              <span className={classNames(variableBlockBaseClass, 'border-gray-3')}>{value}</span>
              <span>{description}</span>
            </div>
          ),
          type: URL_VARIABLES.includes(variable) ? 'url' : 'text',
        };
      });
    },
    [t]
  );

  return { generateVariableOptions };
};
